import { makeObservable, action, observable } from "mobx";
import { parseParams } from "../utils/ParamsUtil.mjs";
class TranslateStore {
  constructor(apiService, brandStore) {
    this.apiService = apiService;
    this.brandStore = brandStore;
    makeObservable(this, {
      currentLanguage: observable,
      status: observable,
      et: observable,
      ru: observable,
      en: observable,
      getTranslations: action,
      changeTranslationLanguage: action.bound,
      setTranslations: action.bound,
      setStatus: action
    });
  }
  currentLanguage = "et";
  status = "UNINITIALIZED";
  et = {};
  ru = {};
  en = {};
  loaderPlaceholder = "...";
  getTranslations(lang) {
    this.changeTranslationLanguage(lang);
    if (this.status === "UNINITIALIZED" || this.status === "ERROR") {
      this.setStatus("FETCHING");
      this.apiService.getTranslations().then((translations) => {
        this.setTranslations(translations);
        this.setStatus("FETCHED");
      }).catch(() => {
        this.setStatus("ERROR");
      });
    }
  }
  changeTranslationLanguage(lang) {
    this.currentLanguage = lang;
  }
  translate = (key, paramObject) => {
    if (this.useImperativeMood) {
      const translationKeyImperative = "imperative." + key;
      if (this.translations[translationKeyImperative]) {
        return this.getTranslationForGroup(translationKeyImperative, paramObject);
      }
    }
    return this.getTranslationForGroup(key, paramObject);
  };
  translateHtml = (key, paramObject) => {
    return { __html: this.translate(key, paramObject) };
  };
  setTranslations = (translations) => {
    this.et = translations.et;
    this.ru = translations.ru;
    this.en = translations.en;
  };
  setStatus(status) {
    this.status = status;
  }
  get translations() {
    if (this.currentLanguage === "ru") {
      return this.ru;
    }
    if (this.currentLanguage === "en") {
      return this.en;
    } else {
      return this.et;
    }
  }
  getTranslationForGroup = (key, paramObject) => {
    const translations = this.translations;
    let textValue;
    if (translations) {
      textValue = translations[key];
    }
    if (textValue && paramObject) {
      return parseParams(textValue, paramObject);
    }
    if (textValue) {
      return textValue;
    } else if (this.status === "FETCHED" || this.status === "ERROR") {
      return key;
    } else {
      return this.loaderPlaceholder;
    }
  };
  get useImperativeMood() {
    return this.brandStore.brand !== "TELIA";
  }
  getLocale() {
    if (this.currentLanguage === "ru") {
      return "ru-RU";
    }
    if (this.currentLanguage === "et") {
      return "et-EE";
    }
    return "en-US";
  }
  getTranslationsBasedOnLocale(cardManagerView) {
    return {
      [`${this.getLocale()}`]: {
        payButton: this.translate(
          cardManagerView ? "payment.card-manager.save-card-button" : "payment.card.submit-payment-button"
        ),
        "creditCard.cardNumber.label": this.translate("payment.card.card-number"),
        "creditCard.expiryDate.label": this.translate("payment.card.expiry-date"),
        "creditCard.expiryDate.contextualText": this.translate("payment.card.expiry-date-contextual"),
        "creditCard.securityCode.label": this.translate("payment.card.cvc-code"),
        "creditCard.securityCode.contextualText.3digits": this.translate("payment.card.cvc-code.3digits.contextual"),
        "creditCard.encryptedExpiryDate.aria.iframeTitle": this.translate("payment.card.expiry-date"),
        "creditCard.encryptedCardNumber.aria.iframeTitle": this.translate("payment.card.card-number"),
        "form.instruction": this.translate("payment.card.form-instruction"),
        "paymentMethodsList.storedPayments.label": this.translate("payment.card.stored-payments"),
        "paymentMethodsList.otherPayments.label": this.translate("payment.card.other-payments"),
        "error.va.gen.01": this.translate("payment.card.incomplete-field"),
        "cc.num.900": this.translate("payment.card.notice.card-number-invalid"),
        "cc.num.901": this.translate("payment.card.enter-complete-card-number"),
        "cc.num.902": this.translate("payment.card.invalid-card-number"),
        "cc.num.903": this.translate("payment.card.unsupported-card"),
        "cc.dat.910": this.translate("payment.card.enter-complete-expiry-date"),
        "cc.dat.911": this.translate("payment-credit-card-expiry-date-invalid"),
        "cc.dat.912": this.translate("payment.card.too-old"),
        "cc.dat.913": this.translate("payment.card.date-too-far-in-future"),
        "cc.dat.914": this.translate("payment.card.card-about-to-expire"),
        "cc.yr.917": this.translate("payment.card.enter-expiry-date"),
        "cc.yr.918": this.translate("payment.card.enter-complete-expiry-date"),
        "cc.cvc.920": this.translate("payment.card.enter-cvc-code"),
        "cc.cvc.921": this.translate("payment.card.enter-complete-cvc-code"),
        "storedPaymentMethod.disable.confirmation": this.translate("payment.card.remove-stored-card"),
        "storedPaymentMethod.disable.button": this.translate("payment.card.remove-stored-card.button"),
        "storedPaymentMethod.disable.confirmButton": this.translate("payment.card.remove-stored-card.confirm-button"),
        "storedPaymentMethod.disable.cancelButton": this.translate("payment.card.remove-stored-card.cancel-button"),
        orPayWith: this.translate("payment.card.or-pay-with"),
        storeDetails: this.translate("payment.card.store-details")
      }
    };
  }
}
export {
  TranslateStore as default
};
